import background_1 from "./icons/background_1.webp";
import background_2 from "./icons/background_2.webp";
import background_3 from "./icons/background_3.webp";

export const homeImages = [
  {
    image: background_1,
    body: `Your trusted HR services partner based in Houston, TX, where we
            specialize in connecting talent with opportunity across a wide range
            of industries. Our mission is to bridge the gap between employers
            seeking skilled professionals and individuals looking to advance
            their careers. `,
    title: "",
  },
  {
    image: background_2,
    body: ` On our homepage, you’ll discover the breadth of our services,
            designed to meet the unique needs of both businesses and job
            seekers. We pride ourselves on our industry expertise and
            personalized approach, ensuring that each connection we make is not
            just about filling a position, but about fostering meaningful
            relationships.`,
    title: "",
  },
  {
    image: background_3,
    body: `As you explore our website, we encourage you to take action—whether
            that's contacting us for more information, browsing our job
            listings, or learning more about the tailored solutions we offer.`,
    title: "",
  },
];

export const JobData = {
  hospitals_and_health_care: {
    title: "HOSPITALS & HEALTH CARE",
    body: "The hospitals and healthcare industry, often referred to as the health economy, provides essential services for remedial, preventive, rehabilitative, and palliative care. Recruitment in this sector can be challenging due to the increasing demand for qualified healthcare professionals like physicians and nurses, coupled with limited resources.",
    points: [
      "CEO - Chief Executive Officer",
      "COO - Chief Operating Officer",
      "CFO - Chief Financial Officer",
      "CAO - Chief Accounting Officer",
      "CSO - Chief Scientist Officer",
      "VP of Corporate Communication & Branding",
      "VP of Healthcare Operations",
      "VP of Business Development",
      "VP of Finance",
      "VP of Pharmaceuticals",
      "VP of Patient Care Services",
      "VP of Human Resources",
      "Director of Operations",
      "Director of Finance",
      "Director of Diagnostics",
      "Director of Pharmacy",
      "Doctor of Medicine",
      "Doctor of Physical Therapy",
      "Medical Doctor PhD",
      "Associate Doctor",
      "NP - Nurse Practitioner",
      "RN - Registered Nurse",
      "LVN - Licensed Vocational Nurse",
      "Staff Nurse/Clinical Nurse",
    ],
    image_link: "hospitals_and_health_care.webp",
  },
  medical_devices: {
    title: "MEDICAL DEVICES",
    body: "The term 'medical device' encompasses a wide range of instruments, apparatuses, and related articles used in healthcare. This industry operates within a complex framework of procedures and regulations that significantly contribute to advancements in healthcare markets.",
    points: [
      "VP of Research & Development",
      "VP of Engineering",
      "VP of Compliance",
      "VP of Medical Affairs",
      "VP of Portfolio Solutions",
      "Product Development",
      "Robotic Engineer",
      "VP of Quality Assurance",
      "Director of Quality Assurance",
      "Director of Compliance",
      "Director of Implementation Service",
      "Director of QA Auditor",
      "Software Test Engineer",
      "Test Engineer",
      "Director of e-Health Medical Devices",
      "R&D Engineer",
      "Quality Process Validation Medical Device",
      "Regulatory Affairs",
      "Product Management",
    ],
    image_link: "medical_devices.webp",
  },
  health_care_it: {
    title: "HEALTH CARE IT",
    body: "Our team specializes in Health Care IT recruitment, working closely with hospitals, clinics, and healthcare organizations both domestically and internationally. We pride ourselves on our attention to detail and technical expertise, ensuring we find the right cultural and professional fits for our clients.",
    points: [
      "Analyst",
      "Project Management",
      "Quality Assurance",
      "Software Development",
      "System Analysis",
      "Systems/Network Engineer",
      "Systems Security",
      "Telecommunications",
      "Consultant",
      "Web Developer",
      "Webmaster",
      "Data Analysis",
      "Database Management",
      "Executive",
      "Health Information Administrator",
      "Health Information Technician",
      "Healthcare Informatics",
      "IT Technology Management",
    ],
    image_link: "health_care_it.webp",
  },
  information_technology_it: {
    title: "INFORMATION TECHNOLOGY (IT)",
    body: "The IT sector includes software solutions, hardware, IT services, and research and development. With rapid evolution in this dynamic market, there is a high demand for quality talent.",
    points: [
      "CEO - Chief Executive Officer",
      "CTO - Chief Technology Officer",
      "Quality Assurance",
      "Software Development",
      "IT - Software Services Provider",
      "Product Development (Mobile, Videos)",
      "Product Management",
      "Software Engineers/Programmers",
      "Web Designer",
      "Database Engineer",
      "Program & Project Manager",
      "Application Network Security",
      "Help Desk",
      "IT Support",
      "Desktop Support",
      "Hardware/Software",
      "Product Management Manager",
      "Six Sigma",
      "Quality",
      "Global Communications",
      "Business Analyst",
    ],
    image_link: "information_technology_it.webp",
  },
  engineering: {
    title: "ENGINEERING",
    body: "We focus on STEM recruitment (Science, Technology, Engineering, and Mathematics). Our approach sets us apart, as we partner with clients to address their engineering hiring needs. We conduct in-depth interviews to ensure that candidates accurately represent their skills beyond what is listed on their resumes.",
    points: [
      "Design Head",
      "Production Head",
      "Maintenance Manager",
      "Design Engineer",
      "Controls Engineer",
      "Robotic Engineer",
      "Robotics Engineer - Supervisor",
      "Electrical Engineer",
      "Acoustic Engineer",
      "Filter Engineer",
      "Mechanical Engineer",
      "AutoCAD Designer",
      "Project Manager",
      "Manufacturing Engineer",
      "Maintenance Supervisor",
      "Electrical Engineer - Quality",
      "Electrical Engineer - Controls",
      "Electrical Engineer - Design",
      "Antenna Engineer",
      "ASIC Engineer",
      "IC Designer",
      "Designer/Drafter",
      "Mechanical Engineer",
      "Embedded Software Developer",
      "Mechanical Designer",
      "Piping Engineer",
      "Environment Specialist",
      "Safety Manager",
      "Hardware Engineer",
      "EMC Engineer",
    ],
    image_link: "engineering.webp",
  },
  accounting_and_finance: {
    title: "ACCOUNTING & FINANCE",
    body: "The rapid evolution of technology and business has transformed the accounting and finance landscape. Today’s competitive and unpredictable business environment requires skilled leaders who can adapt swiftly to market changes.",
    points: [
      "CAO - Chief Accounting Officer",
      "Director of Billing",
      "Operations Manager",
      "Controller",
      "Auditor (Internal or External)",
      "Accounts Payable Manager/Supervisor/Staff",
      "Accounts Receivable Manager/Supervisor/Staff",
      "Tax Manager/Tax Staff",
      "Supervisor/Staff Accountant",
      "CFO - Chief Financial Officer",
      "Vice President of Finance",
      "Director of Finance",
      "Finance Manager",
      "Operations Manager",
      "Financial Analyst",
      "Report Analyst",
      "Financial Planning & Analysis",
    ],
    image_link: "accounting_and_finance.webp",
  },
  legal: {
    title: "LEGAL",
    body: "Our organization has successfully placed numerous high-level attorneys and paralegals in prestigious law firms and corporations across California and nationwide since our founding in 2006. We pride ourselves on our high success rate and customized recruitment experiences, underpinned by deep industry knowledge.",
    points: [
      "Immigration Attorney",
      "Staff Attorney",
      "General Attorney",
      "Attorney (Civil Litigation)",
      "Attorney (Litigation - Strategic Risk & Complex)",
      "Attorney (Litigation I/II/III/IV)",
      "Attorney (Probate Litigation)",
      "Corporate Attorney",
      "Attorney Workers Compensation",
      "Plaintiff Employment Attorney",
      "Employment Attorney",
      "Corporate Transactional Attorney",
      "Attorney/Lawyer Family Law",
      "Supervising Child Support Attorney",
      "Personal Injury Attorney",
      "Insurance Defense Attorney",
      "Patent Attorney",
      "Criminal Defense Attorney",
      "Assistant Attorney General – AAG (Civil and Criminal Divisions)",
      "Assistant Attorney General – AAG (Felony Criminal Prosecutions)",
      "Trial Attorney",
      "Estate Planning Attorney",
      "Transactional Attorney",
      "Commercial Finance Attorney",
      "Crypto Attorney",
      "Paralegal (Immigration/Case Manager)",
      "Paralegal I & II (Immigration)",
      "Paralegal (Litigation)",
      "Paralegal (Plaintiff Litigation)",
      "Sr. Paralegal (Probate)",
      "Paralegal (Estate Planning & Probate)",
      "Paralegal (Trust & Estate)",
      "Paralegal (Intellectual Property/Trademark)",
      "Corporate Paralegal (Private Equity Firm)",
      "Paralegal - Operations/Funds",
      "Legal Assistant/Paralegal - Commercial Litigation",
      "Legal Assistant/Paralegal – Insurance Defense",
      "Paralegal (Advertising & Marketing)",
      "Paralegal (Wage & Hour)",
      "Paralegal (Personal Injury)",
      "Paralegal (Contract Specialist)",
      "Paralegal (Patent)",
    ],
    image_link: "legal.webp",
  },
  banking: {
    title: "BANKING",
    body: "Banking, mortgages, and investment banking encompass various sectors related to mergers and acquisitions, characterized by high funds and risks. This environment has led to an increase in available positions across the banking sector.",
    points: [
      "CEO - Chief Executive Officer",
      "Firm CEO/MD - Leading Broking & Investment",
      "Company Executive Director",
      "Bank Director",
      "Bank Country Head",
      "Bank Head",
      "Asset Management Specialist",
      "Underwriters",
    ],
    image_link: "banking.webp",
  },
  analytics: {
    title: "ANALYTICS",
    body: "The fields of digital information, big data, analytics, and artificial intelligence are reshaping business management today. Analytics positions are continually in demand, reflecting the rapid growth of this industry.",
    points: [
      "VP of Analytics",
      "Data Analysis and Operations",
      "Financial Analyst",
      "Business Analyst",
      "Digital Marketing and Analytics",
      "Product Analyst",
      "Marketing Specialist",
      "Product Marketing",
      "Market Research and Analysis",
      "Customer Support Analytics",
    ],
    image_link: "analytics.webp",
  },
  human_resources_hr: {
    title: "HUMAN RESOURCES (HR)",
    body: "Human Resources recruitment is evolving as businesses adopt new operational models to manage human capital more effectively. The HR function continues to expand, encompassing new roles and responsibilities.",
    points: [
      "Director of Talent Acquisition",
      "Director of Human Resources",
      "VP of Human Resources",
      "Director of Labor Relations",
      "Director of Compensation and Benefits",
      "Director of Compensation and Benefits Analytics",
      "Chief People Officer",
      "Employee Relations Manager",
      "HR Business Partner",
      "HR Compliance Officer",
    ],
    image_link: "human_resources_hr.webp",
  },
};
